import { render, staticRenderFns } from "./editor-sidebar.vue?vue&type=template&id=29635ef0&scoped=true"
import script from "./editor-sidebar.vue?vue&type=script&lang=js"
export * from "./editor-sidebar.vue?vue&type=script&lang=js"
import style0 from "./editor-sidebar.vue?vue&type=style&index=0&id=29635ef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29635ef0",
  null
  
)

export default component.exports